import React, { useMemo } from "react";

import "./index.scss";

interface CustomTooltipProps {
  payload?: any[];
  tickFormatter: (value: number) => string;
}

const getValue = (p: { name: string; payload: { label: number; value: number } }) => {
  if (p.name === "Artifact") {
    return p.payload.label || 0;
  }

  return p.payload.value || 0;
};

const CustomTooltip = ({ payload, tickFormatter }: CustomTooltipProps) => {
  const label = useMemo(() => {
    const p = payload?.find(Boolean);
    if (!p) return "-";

    return tickFormatter(p.payload.time);
  }, [payload, tickFormatter]);

  return payload?.length ? (
    <div className="patient-chart-custom-tooltip">
      <div className="label-text">{label}</div>
      {payload.map((p) => (
        <div key={p.name} className="custom-content" style={{ color: p.color }}>
          {p.name} {getValue(p)}
        </div>
      ))}
    </div>
  ) : null;
};

export default CustomTooltip;
